import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import { useParams } from 'react-router-dom'
import DealershipForm from '../../components/forms/DealershipForm'
import { useGetDealership } from '../../hooks/api/dealerships'

const EditDealership = () => {
  const { dealershipId } = useParams()
  const { data: dealership, refetch } = useGetDealership(dealershipId)
  return (
    <Container maxWidth='md' sx={{ py: 2 }}>
      <Box mb={2}>
        <Typography variant='h5'>Edit User</Typography>
      </Box>
      {dealership && <DealershipForm dealership={dealership} refetch={refetch} />}
    </Container>
  )
}

export default EditDealership
